import React, { Suspense, useEffect, useState } from 'react';
import Header from '../Header/header';
import { CommonUtilities } from '../../commonUtils';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';

import SearchFilter from '../../components/Templates/SearchFilter';
import Contracts from '../../components/Templates/Contracts';
import ButtonsLabelsInputs from '../../components/Templates/ButtonsLabelsInputs'
import ButtonLayoutDesign from './ButtonLayoutDesing';


export default function Templates(autoOpen: any) {

    let [activeMenu, setActiveMenu] = useState("ButtonsLabelsInputs");
    useEffect(() => {



    }, []);

    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    const closeModal = (e:any) =>{ 
        //setShowTab(false);
        const modal = document.getElementById("myModal") as HTMLElement; 
        modal?.classList.remove("displayItem"); 
        modal?.classList.add("displayNoneItem"); 
        document.body.classList.remove("HiddenoverflowX");
    }

    return (
        <div id="myModal" className="modal pLarge ws-12 ">                 
            

            <style>{` 

                .box{ border-radius : 4px !important ;} 
                [class*="btn"], .nav.nav-tabs li, input{ border-radius : 4px !important ;} 
                li{ border-radius : 4px !important ;} 
                .topFrame{ border-radius: 6px; } 
                .tagging span{border-radius: 5px;}

            `}</style>
            
            <a onClick={()=>closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{position : "inherit"}} href="../../">
                <i className="icon-close3 danger"></i>
            </a> 


            <div  className="allowHscroll allowVscroll full-height-vh90 ws-12 box" style={{minHeight:"80%"}}>
                
                <div className="ws-12 ">
                    <div className="ws-2 pm borderReset full-height pLarge">
                        <div className="ws-12 text-center pLarge mtll mbl">
                            <img alt="Korrect"  className="pull-none" src={korrectLogo} width={50} />
                        </div>

                        <ul className="main-menu pll prl ws-12">
                            <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Design Templates</a>
                            <ul >
                                
                                <li className={activeMenu === 'NewButton' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('NewButton') }}> NewButton </a>
                                </li>

                                <li className={activeMenu === 'ButtonsLabelsInputs' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('ButtonsLabelsInputs') }}> Buttons / Labels / Inputs </a>
                                </li>

                                <li className={activeMenu === 'SearchFilter' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('SearchFilter') }}> Search / Filter </a>
                                </li>

                                <li className={activeMenu === 'Contracts' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('Contracts') }}> Contracts </a>
                                </li>

                                <li className={activeMenu === 'Projects' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('Projects') }}> Projects </a>
                                </li>

                                <li className={activeMenu === 'Tracks' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('Tracks') }}> Tracks </a>
                                </li>

                                <li className={activeMenu === 'Release' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('Release') }}> Release </a>
                                </li>

                                <li className={activeMenu === 'Song' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('Song') }}> Song </a>
                                </li>
                            </ul>

                        </ul> 
                    </div>

                    <div className="ws-10 landing"> 
                        {(activeMenu === 'NewButton') && <ButtonLayoutDesign />}  
                        {(activeMenu === 'ButtonsLabelsInputs') && <ButtonsLabelsInputs />}         
                        {(activeMenu === 'SearchFilter') && <SearchFilter />}
                        {(activeMenu === 'Contracts') && <Contracts />}
                    </div>  
                </div>               
            </div>                                    
            
        </div>
    )
}